<template>
  <div class="record_main">
    <div class="record">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="nickname" label="用户昵称" width="180">
        </el-table-column>
        <el-table-column prop="mobile_phone" label="手机号" width="180">
        </el-table-column>
        <el-table-column prop="identity" label="身份"> </el-table-column>
        <!-- <el-table-column prop="test_result_score" label="得分">
        </el-table-column> -->
        <el-table-column prop="test_result" label="测试结果"> </el-table-column>
        <el-table-column prop="created_at" label="提交时间"> </el-table-column>
        <el-table-column prop="register_at" label="注册时间"> </el-table-column>
        <el-table-column prop="user_receive_num" label="用户领取数">
        </el-table-column>
        <el-table-column prop="give_receive_num" label="邀请领课数">
        </el-table-column>
        <el-table-column prop="invite_click_num" label="邀请点击数">
        </el-table-column>
        <el-table-column prop="invite_test_num" label="邀请测试人数">
        </el-table-column>
      </el-table>
    </div>
    <div class="bott">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalItems"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handlePageChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getPartakeRecord } from "@/api/coupon";
export default {
  data() {
    return {
      tableData: [
        {
          user_id: 5161998,
          nickname: "Long", // 昵称
          mobile_phone: "15611003131", // 手机号
          register_at: "2023-08-01 13:57:25", // 注册时间
          test_result_score: 0, // 得分
          test_result: "维度1", // 测试结果
          created_at: "2023-08-22 14:48:29", // 提交时间
          user_receive_num: 1, // 用户领课数
          give_receive_num: 2, // 邀请领课数
          invite_click_num: 3, // 邀请点击数
          invite_test_num: 4, // 邀请测试人数
          identity: "普通用户", // 用户身份
          testid:0
        },
      ],
      query: {
        limit: 10,
        page: 1,
        test_id:0
      },
      pageSize: 10, // 每页显示的条数
      totalItems:0,
      currentPage:1,
    };
  },
  mounted() {
    this.searchData()
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.slice(hash.indexOf("?") + 1));
    this.query.test_id = params.get("id");
  },
  methods: {
    searchData() {
        getPartakeRecord(this.query).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.tableData = res.data.list;
          this.totalItems = res.data.total;
        }
      });
    },
    handlePageChange(currentPage) {
      // 当页码改变时，更新 currentPage 并重新获取数据
      console.log(currentPage);
      this.query.page = currentPage;
      this.searchData();
    },
  },
};
</script>

<style>
</style>